import {
  Box,
  Button,
  HStack,
  IconButton,
  Link,
  Spacer,
  Text,
  VStack,
  Image,
  LinkBox,
  Heading,
  LinkOverlay,
} from "@chakra-ui/react";
import { Link as LinkWrap } from "react-router-dom";
// import { IoReaderOutline, IoAnalytics } from "react-icons/io5";
// import { BiPencil } from "react-icons/bi";
import { useQuery, useReactiveVar } from "@apollo/client";
import { useState, useEffect } from "react";
import {
  GET_REVIEWED_URL,
} from "../../graphql/operations/campaignOperations/operations";
import { ComponentLoading } from "../../components/loading/ComponentLoading";
import { userDetailsVar } from "../../lib/cache";
import { useHitlFilters } from ".";
import { GET_URL_CLASSIFICATION } from "../../graphqlExternal/operations/operations";
import { LuExternalLink } from "react-icons/lu";
import { encodeURL } from "../../utils/encodeUrl";
import { AccountsAgencyPartnerChoices } from "../../graphql/generated";

interface TitleLinkProps {
  url: string;
  showNote: boolean;
  correctionButton?: boolean;
  reviewButton?: boolean;
  predictiveCorrections?: boolean;
  title?: string;
  showLink: boolean;
  showOverlay?: boolean;
}

export const TitleLink = ({
  url,
  showNote,
  correctionButton = false,
  reviewButton = false,
  predictiveCorrections = false,
  title = "",
  showLink,
  showOverlay = true,
}: TitleLinkProps) => {
  const currentUser = useReactiveVar(userDetailsVar);
  const hitlFilters = useHitlFilters();
  const [isPredictiveButtonActive, setIsPredictiveButtonActive] =
    useState(true);
  const [isCorrectionButtonActive, setIsCorrectionButtonActive] =
    useState(true);
  const [isReviewButtonActive, setIsReviewButtonActive] = useState(true);
  const [isImageError, setIsImageError] = useState(false);
  const predictionsUrl = (location.pathname.includes("predictive-correction") && !location.pathname.includes(encodeURL(url)))


  // query is only executed when component variable is set to true
  // const {
  //   loading: predictiveLoading,
  //   error: predictiveError,
  //   data: predictiveData,
  // } = useQuery(GET_PREDICTIVE_CORRECTIONS, {
  //   skip: !predictiveCorrections,
  //   variables: {
  //     predictedFromUrl: url,
  //   },
  //   fetchPolicy: "cache-and-network",
  // });

  const {
    loading: correctionLoading,
    error: correctionError,
    data: correctionData,
  } = useQuery(GET_REVIEWED_URL, {
    skip: !correctionButton && !reviewButton,
    variables: {
      url: url,
    },
    fetchPolicy: "cache-and-network",
  });

  const {
    data: reviewData,
    loading: reviewLoading,
    error: reviewError,
  } = useQuery(GET_URL_CLASSIFICATION, {
    skip: !reviewButton,
    context: { clientName: "illumaDbEndpoint", type: "graphql" },
    variables: {
      publisher: hitlFilters.publisherFilter.value,
      url: url,
    },
    fetchPolicy: "cache-and-network",
  });

  // if (reviewError) {
  //   return <></>;
  // }

  // Predictive button

  // const favicon = getFaviconUrl(url) !== `none`

  const handleImageError = () => {
    setIsImageError(true)
  }

  // Predictive button
  useEffect(() => {
    if (
      // predictiveError ||
      // !predictiveData ||
      // predictiveData.predictiveCorrections.length === 0 || !predictiveCorrections
      !correctionData || correctionError || !predictiveCorrections
    ) {
      setIsPredictiveButtonActive(false);
    } else {
      setIsPredictiveButtonActive(true);
    }
  }, [correctionData, location.pathname]);
  // Correction button
  useEffect(() => {
    if (!correctionData || correctionError || !correctionButton) {
      setIsCorrectionButtonActive(false);
    } else {
      setIsCorrectionButtonActive(true);
    }
  }, [correctionData, location.pathname]);


  // Review button
  useEffect(() => {
    if ((reviewError ||
      !reviewData ||
      reviewData.urlClassification === null ||
      reviewData.urlClassification.pageUrl === null) &&
      (!correctionData?.reviewedUrl?.originalClassification || correctionData?.reviewedUrl?.originalClassification === null) ||
      !reviewButton) {
      setIsReviewButtonActive(false);
    } else {
      setIsReviewButtonActive(true);
    }
  }, [reviewData, correctionData, location.pathname]);

  if (correctionLoading || reviewLoading) {
    return <ComponentLoading text="loading..." />;
  }

  return (
    <Box mx={0} my={0} width="100%">
      <HStack width="100%" justify={"space-between"} align="center" p={0}>
        {title.length > 0 && (
          <VStack alignItems={"start"} p={2}>
            <Text fontWeight={"semibold"} fontSize={"18px"} whiteSpace="nowrap">
              {title}
            </Text>
            <Text hidden={!showNote} color={"muted"}>
              Note: At least one category needs to be selected to submit review.
              Tick checkbox if option is relevant to URL and cross checkbox if
              option is not relevent to URL.
            </Text>
            <Spacer />
          </VStack>
        )}
        <HStack  justify={"flex-end"} width="100%" >
        {isCorrectionButtonActive && (
          // encodeURL required as TitleLink is now set at HITL Index page
          <LinkWrap to={`./${encodeURL(url)}/past-review`}>
            <IconButton
              // backgroundColor={"primary.dark"}
              aria-label={"link to correction"}
              // icon={<IoReaderOutline />}
              variant={"blueButton"}
              display={["flex", null, "none", null, null]}
            />
            <Button
              px={4}
              // backgroundColor={"primary.dark"}
              variant={"blueButton"}
              fontSize={["sm", null, null, "md", null]}
              display={["none", null, "flex", null, null]}
              // leftIcon={
              //   <Icon
              //     as={IoReaderOutline}
              //     w={[4, null, null, 5, null]}
              //     h={[4, null, null, 5, null]}
              //   />
              // }
              // hidden={!currentUser?.isStaff}
            >
              Correction
            </Button>
          </LinkWrap>
        )}
        {isReviewButtonActive && (
          <LinkWrap to={predictionsUrl? `../../${encodeURL(url)}/review` :`./${encodeURL(url)}/review`}>
            <IconButton
              // backgroundColor={"primary.dark"}
              aria-label={"link to url review"}
              // icon={<BiPencil />}
              variant={"blueButton"}
              display={["flex", null, "none", null, null]}
            />
            <Button
              px={4}
              // backgroundColor={"primary.dark"}
              variant={"blueButton"}
              fontSize={["sm", null, null, "md", null]}
              display={["none", null, "flex", null, null]}
              // leftIcon={
              //   <Icon
              //     as={BiPencil}
              //     w={[4, null, null, 5, null]}
              //     h={[4, null, null, 5, null]}
              //   />
              // }
              // hidden={!currentUser?.isStaff}
            >
              Review
            </Button>
          </LinkWrap>
        )}
        {/* Currently only visible to staff and NewsUk*/}
        {(currentUser?.isStaff || currentUser?.agency.partner === AccountsAgencyPartnerChoices.NewsUk) && isPredictiveButtonActive && (
          <LinkWrap to={`./${encodeURL(url)}/predictive-correction`}>
            <IconButton
              // backgroundColor={"primary.dark"}
              aria-label={"link to correction"}
              // icon={<IoReaderOutline />}
              variant={"blueButton"}
              display={["flex", null, "none", null, null]}
            />
            <Button
              px={4}
              // backgroundColor={"primary.dark"}
              variant={"blueButton"}
              fontSize={["sm", null, null, "md", null]}
              display={["none", null, "flex", null, null]}
              // leftIcon={
              //   <Icon
              //     as={IoAnalytics}
              //     w={[4, null, null, 5, null]}
              //     h={[4, null, null, 5, null]}
              //   />
              // }
              // hidden={!currentUser?.isStaff}
            >
              Predictions
            </Button>
          </LinkWrap>
        )}
        </HStack>
      </HStack>

      <VStack p={showLink ? 4 : 2}>
        {showLink && (
          <LinkBox
            as="article"
            backgroundColor={"#F9FAFB"}
            borderRadius="md"
            p={2}
            width="100%"

          >
            <HStack width={"100%"} alignContent={"flex-start"} spacing={4} ml={2} mr={5}>
            {(!isImageError && showOverlay) && (
              <LinkOverlay href={url}>
                <Image
                src={getFaviconUrl(url)}
                alt={`${url} icon`}
                boxSize="50px"
                borderRadius="md"
                fallbackSrc="https://via.placeholder.com/20"
                onError={handleImageError}
              />
              </LinkOverlay>
              )}
              <VStack alignItems={"flex-start"} w={"100%"} mr={5}>
                <Heading fontWeight={"semibold"} fontSize={"13px"} alignItems={"flex-start"}>
                  <LinkOverlay href={url} alignItems={"flex-start"}>
                    {getSiteNameFromUrl(url).toUpperCase()}
                  </LinkOverlay>
                </Heading>
                <Link
                  href={url}
                  isExternal
                  color={"#91c9d7"}
                  textDecoration={"none"}
                  _hover={{
                    textDecoration: "none",
                  }}
                  width={"100%"}
                  // isTruncated={true}
                  overflowY={"scroll"}
                  maxH={100}
                  mr={5}
                >
                  {url}
                </Link>
              </VStack>
              <Spacer />
              <Link
                href={url}
                isExternal
                backgroundColor="#D2EFF7"
                borderRadius="md"
                width="40px"
                height="40px"
                display="flex"
                justifyContent="center"
                alignItems="center"

              >
                <LuExternalLink size={20} color="#91c9d7" />
              </Link>
              <Spacer />
            </HStack>
          </LinkBox>
        )}
      </VStack>
    </Box>
  );
};

const getSiteNameFromUrl = (url: string): string => {
  // Slicing the url to get only the site name
  const firstPosition = url.indexOf("//");
  const lastPosition = url.indexOf("/", firstPosition + 2);
  let siteName = url.slice(firstPosition + 2, lastPosition);

  // remove common domains from site name
  const removeFromUrls = [
    "www.",
    ".com",
    ".net",
    ".org",
    ".co.uk",
    ".us",
    ".int",
    ".edu",
    ".cn",
    ".de",
    ".nl",
    ".ru",
    ".br",
    ".xyz",
    ".live",
  ];
  removeFromUrls.forEach((rem) => (siteName = siteName.replace(rem, "")));

  return siteName;
};

const getFaviconUrl = (url: string) => {
  try {
    const domain = new URL(url).origin;
    return `${domain}/favicon.ico`;
  } catch (error) {
    console.error("Invalid URL", error);
    return `none`;
  }
};
